import {
  createUserWithEmailAndPassword,
  SAMLAuthProvider,
  signInWithCustomToken,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
  updatePassword,
} from 'firebase/auth';

import { generateRandomPassword } from '@/modules/common/application/password';
import { TenantInfo } from '@/modules/common/types';
import Firebase from '@/services/firebase.service';

async function getAuth(tenantId: string | null) {
  const firebase = new Firebase();
  const auth = firebase.getAuth();
  auth.tenantId = tenantId;
  return auth;
}

export async function loginWithEmailPassword(
  email: string,
  password: string,
  tenantInfo: TenantInfo
) {
  const auth = await getAuth(tenantInfo.tenantId || null);

  return signInWithEmailAndPassword(auth, email, password);
}

export async function loginWithSAML(tenantInfo: TenantInfo) {
  const { tenantId, providerId } = tenantInfo;
  const firebase = new Firebase();
  const auth = firebase.getAuth();
  if (!tenantId || !providerId) {
    throw new Error('Tenant ID and provider ID are required');
  }
  auth.tenantId = tenantId;
  const provider = new SAMLAuthProvider(providerId);
  return signInWithPopup(auth, provider);
}

export async function loginWithToken(token: string, tenantId: string | null) {
  const auth = await getAuth(tenantId || null);
  return signInWithCustomToken(auth, token);
}

export async function createFirebaseUser(email: string, tenantId: string | null) {
  const auth = await getAuth(tenantId || null);
  return createUserWithEmailAndPassword(auth, email, generateRandomPassword());
}

export async function updateFirebasePassword(newPassword: string, tenantId: string | null) {
  const auth = await getAuth(tenantId || null);
  const user = auth.currentUser;
  if (!user) {
    throw new Error('User not found');
  }
  return updatePassword(user, newPassword);
}

export async function logoutUser(tenantId: string | null) {
  const auth = await getAuth(tenantId || null);
  return signOut(auth);
}
